import type { WhiteLabel } from '@skytech/types'

import { bgColorClassByWhiteLabel } from './style-constants'

const STOCK_SUCCESS_LIMIT = 5
const STOCK_WARNING_LIMIT = 1

export const inStockStatusStyle = (inStock: string | null, whiteLabel: WhiteLabel) => {
  const stockValue = Number(inStock?.replace(/\+|</, '')) || 0
  const color = bgColorClassByWhiteLabel[whiteLabel] || bgColorClassByWhiteLabel.skytech

  if (stockValue >= STOCK_SUCCESS_LIMIT && inStock !== null && !inStock.includes('<'))
    return color!.success

  if (inStock !== null && stockValue >= STOCK_WARNING_LIMIT) return color!.warning

  return color!.error
}
